import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=e0edcaf2&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=ts"
export * from "./BaseButton.vue?vue&type=script&lang=ts"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=e0edcaf2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0edcaf2",
  null
  
)

export default component.exports